import React from "react";

import Slider from "react-slick";

const Testimonials = () => {
  const reviews = [
    {
      name: "Nicole Green",
      position: "TransUnion Public Sector | Startup Growth Leader",
      src: "images/testimonial/NicoleGreen.png",
      desc: "“Dane is a leader, mentor and team player of the highest character who also happens to be a killer CFO. He brought a new level of integrity and rigor to our internal processes. His foresight with the finance committee on Team Rubicon's Board of Directors positioned us to adapt to and navigate through COVID. I worked at Deloitte before working with Dane and I was consistently impressed by his effort to be a lockstep partner to our fundraising team.”",
    },
    {
      name: "John McFadden",
      position:
        "Sales and Financial Analysis | Sales and Financial Forecasting | Business Intelligence | Strategic Planning | Team Development",
      src: "images/testimonial/John.jpg",
      desc: " “I am happy Working with printing and typesetting industry. Quidam lisque persius interesset his et, in quot quidam persequeris essent possim iriure. simply dummy text of the printing and typesetting industry.”",
    },
    {
      name: "Aksel Lielmanis",
      position:
        "Sales & Marketing Executive | Sports, Media & Entertainment | Strategic Partnerships",
      src: "images/testimonial/aksel.jpg",
      desc: " “For seven years Dane and I worked closely together as part of the executive leadership team in Canada. His proficiency in budgeting, financial modelling, and executive reporting married with a strong collaborative spirit was unparalleled. Much of my financial and business IQ was enhanced as a result of my time working with Dane.”",
    },
  ];

  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-prev slick-arrow" + (currentSlide === 0 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
      type="button"
    >
      <i className="fa fa-chevron-left"></i>
    </button>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-next slick-arrow" +
        (currentSlide === slideCount - 1 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
      type="button"
    >
      <i className="fa fa-chevron-right"></i>
    </button>
  );

  var settings = {
    dots: true,
    arrows: true,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4500,
  };

  return (
    <section id="testimonial" className="section bg-secondary">
      <div className="container">
        {/* Heading */}
        <p className="text-center mb-2 wow fadeIn">
          <span className="bg-primary text-dark px-2">Client Speak</span>
        </p>
        <h2 className="text-10 fw-600 text-white text-center mb-5 wow fadeIn">
          What Some of my Clients Say
        </h2>
        {/* Heading end */}
        <div className="row">
          <div className="col-lg-9 mx-auto wow fadeInUp">
            <Slider {...settings}>
              {reviews.length > 0 &&
                reviews.map((review, index) => (
                  <div className="item text-center px-5" key={index}>
                    <span className="text-9 text-primary">
                      <i className="fa fa-quote-left" />
                    </span>
                    <p className="text-5 text-white my-3">{review.desc}</p>

                    {/* Avatar — fixed size */}
                    <img
                      className="img-fluid d-inline-block rounded-circle shadow"
                      src={review.src}
                      alt={review.name}
                      style={{
                        width: "70px",
                        height: "70px",
                        objectFit: "cover",
                        marginBottom: "12px",
                      }}
                    />

                    <strong className="d-block text-3 fw-600 text-white">
                      {review.name}
                    </strong>
                    <span className="text-light">{review.position}</span>
                  </div>
                ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
